import { render, staticRenderFns } from "./SuListPage.vue?vue&type=template&id=250c2a02&scoped=true&"
import script from "./SuListPage.vue?vue&type=script&lang=js&"
export * from "./SuListPage.vue?vue&type=script&lang=js&"
import style0 from "./SuListPage.vue?vue&type=style&index=0&id=250c2a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c2a02",
  null
  
)

export default component.exports